export enum SupportedLanguage {
  FR = "fr",
}
